import { useEffect } from 'react';

const mimeTypeToFormat = {
    'font/ttf': 'truetype',
    'font/otf': 'opentype',
    'font/woff': 'woff',
    'font/woff2': 'woff2',
    'application/font-woff': 'woff',
};

function useLoadFonts( fonts = [] ) {
    useEffect( () => {
        if ( fonts?.length <= 0 ) {
            // console.warn( 'useLoadFonts requires at least one font to run.' );
            return;
        }

        const styleElements = [];
        const sampleOutputElements = [];
        for ( let i = 0; i < fonts?.length; i++ ) {
            const font = fonts[i];
            const files = font?.files || [];
            
            for ( let j = 0; j < files.length; j++ ) {
                const file = files[j];
                if ( file?.name == null || file?.shopify_cdn_url == null || file?.type == null ) {
                    console.warn( `Could not load font with id "[${file?.id}]"` );
                    continue;
                }

                const style = document.createElement('style');
                const textNode = document.createTextNode(`
                    @font-face {
                        font-family: '${font?.font_name}';
                        src: url('${file.shopify_cdn_url}') format('${mimeTypeToFormat[file.type]}');
                        font-weight: ${font?.font_weight};
                        font-style: ${font?.font_style};
                    }
                `);
                style.appendChild( textNode );

                const sampleOutput = document.createElement('span');
                sampleOutput.textContent = 'Aa';
                sampleOutput.style.fontFamily = font?.font_name;
                sampleOutput.style.position = 'absolute';
                sampleOutput.style.visibility = 'hidden';
                sampleOutput.style.width = '0';
                sampleOutput.style.height = '0';
                sampleOutput.style.overflow = 'hidden';

                document.head.appendChild( style );
                document.body.appendChild( sampleOutput );
                
                styleElements.push( style );
                sampleOutputElements.push( sampleOutput );
            }
        }

        return () => {
            for ( let i = 0; i < styleElements.length; i++ ) {
                document.head.removeChild( styleElements[i] );
            }

            for ( let i = 0; i < sampleOutputElements.length; i++ ) {
                document.body.removeChild( sampleOutputElements[i] );
            }
        }
    } , [ fonts ] );
}

export default useLoadFonts;